import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentGeneralLedgerFilterSelection on GeneralLedgerFilterSelection {
    attributeId
    values
    __typename
  }
`
// TODO - Check if types are okay here. Probably should be reworked
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentGeneralLedgerFilterSelectionFragment,
  ents.extra.rate.gl.Filter.Selection
>({
  attributeId: selection =>
    selection.attributeId as ents.core.dms.models.Attribute.Id,
  values: selection => selection.values as string[],
})
